import { createRouter, createWebHistory } from 'vue-router'
import WebTop from '../views/WebTop.vue'
import AccessibilityInfo from '../views/AccessibilityInfo.vue'

const routes = [
  {
    path: '/',
    name: 'webtop',
    component: WebTop,
    // meta: { noLogin: true },
  },
  {
    path: '/home',
    name: 'home',
    // auth redirect
    component: WebTop,
  },
  {
    path: '/enquiryhome',
    name: 'enquiryhome',
    // inner redirect
    component: () => import('../views/Home.vue')
  },
  {
    path: '/enquirylist',
    name: 'enquirylist',
    // auth redirect
    component: WebTop,
  },
  {
    path: '/enquiryinfolist',
    name: 'enquiryinfolist',
    // inner redirect
    component: () => import('../views/EnquiryList.vue')
  },
  {
    path: '/enquirydetails',
    name: 'enquirydetails',
    // inner redirect
    component: () => import('../views/EnquiryDetails.vue')
  },
  {
    path: '/inactiveinfo',
    name: 'inactiveinfo',
    // inner redirect
    component: () => import('../views/InactiveInfo.vue')
  },
  {
    path: '/accessibility',
    name: 'accessibility',
    component: AccessibilityInfo,
  },
]

const router = createRouter({
  history:createWebHistory(),
  routes
})

// router.beforeResolve(async (to, from, next) => {
//   // if (to.matched.some(record => record.meta.noLogin)) {
//   //   return next()
//   // }
//   // let user = await getUser();
//   // if (user) {
//   //   return next();
//   // }
//   return next({path: '/'});
// });

export default router
